module.exports = __webpack_public_path__ + "src/assets/images/logo-benji.png?a91bb6467c8c805f6f8aef72998e4aa4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-benji.png
// module id = 1015
// module chunks = 1